import React from 'react';
import { Link } from 'react-router-dom';
interface WorkMirrorStartModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function WorkMirrorStartModal({
  isOpen,
  onClose
}: WorkMirrorStartModalProps) {
  if (!isOpen) return null;
  return <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/80 z-50 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-326" />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-327">
        <div className="relative bg-[#0A0A0A] border border-[#2B2B2B] w-full max-w-lg" role="dialog" aria-modal="true" aria-labelledby="modal-title" onClick={e => e.stopPropagation()} data-id="element-328">
          {/* Close button - subtle */}
          <button onClick={onClose} className="absolute top-4 right-4 sm:top-5 sm:right-5 text-gray-600 hover:text-[#F5F5F5] transition-colors" aria-label="Close" data-id="element-329">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-330">
              <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-id="element-331" />
            </svg>
          </button>

          {/* Content - generous spacing */}
          <div className="p-8 sm:p-12 space-y-10 sm:space-y-12" data-id="element-332">
            {/* Title */}
            <div data-id="element-333">
              <h2 id="modal-title" className="text-3xl sm:text-4xl font-serif text-[#F5F5F5] leading-tight" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-334">
                Calibration
              </h2>
            </div>

            {/* Body copy - spacious */}
            <div className="space-y-6 text-base sm:text-lg text-gray-400 leading-relaxed" data-id="element-335">
              <p data-id="element-336">
                This helps the mirror understand
                <br data-id="element-337" />
                how your work system tends to move.
              </p>

              <p data-id="element-338">
                There are no right answers.
                <br data-id="element-339" />
                You're not being evaluated.
              </p>

              <p data-id="element-340">It takes about 3 minutes.</p>
            </div>

            {/* Micro-line */}
            <div className="pt-4 border-t border-[#2B2B2B]" data-id="element-341">
              <p className="text-sm text-gray-600" data-id="element-342">
                Answer based on what usually happens — not what you intend.
              </p>
            </div>

            {/* Actions */}
            <div className="space-y-6 pt-4" data-id="element-343">
              <Link to="/mirrors/work/begin" className="block w-full px-8 py-4 bg-[#F5F5F5] text-[#0A0A0A] text-center text-sm font-medium tracking-widest uppercase hover:bg-gray-200 transition-colors" data-id="element-344">
                Begin Calibration
              </Link>

              <div className="flex justify-center" data-id="element-345">
                <button onClick={onClose} className="text-sm text-gray-600 hover:text-gray-400 transition-colors" data-id="element-346">
                  Skip for now
                </button>
              </div>
            </div>

            {/* Footnote */}
            <div className="pt-6 border-t border-[#2B2B2B]" data-id="element-347">
              <p className="text-xs text-gray-600 leading-relaxed" data-id="element-348">
                You can refine this later.
                <br data-id="element-349" />
                The mirror sharpens over time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>;
}